import React from "react";

function QuizQuestion({ question, index, onAnswer }) {
    return (
        <div>
            <h4>{index + 1}. {question.question}</h4>
            {question.options.map((opt, i) => (
                <label key={i}>
                    <input
                        type="radio"
                        name={`q${index}`}
                        value={opt}
                        onChange={() => onAnswer(index, opt)}
                    />
                    {opt}
                </label>
            ))}
        </div>
    );
}

export default QuizQuestion;
